import React, { useEffect, useState } from 'react'
import { CircularProgress, Typography, withStyles } from '@material-ui/core'
import { Selections, FileUpload } from '..'
import { CoreButton, CoreTextField } from 'src/components/core'
import styles from './styles'
import { useHistory, useLocation } from 'react-router-dom'
import {
  llmGetChatMessagesSuccess,
  llmSetChatId,
  llmGetTranslatedContentAction,
} from 'src/reducers/llm/action'
import { useDispatch, useSelector } from 'react-redux'
import CountrySelect from 'src/components/language-selection'
import { getLocalizationStringOfTypeService } from 'src/api/common'
import CustomizedSwitch from 'src/components/customized-switch'
import { track } from '@amplitude/analytics-browser'
const Description = props => {
  const { classes, fromChat } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const [creationType, setCreationType] = useState(0)
  const [loading, setLoading] = useState(false)
  const [languageLoading, setLanguageLoading] = useState(false)
  const [description, setDescription] = useState('')

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const collectionId = searchParams.get('collectionId')

  const chatId = useSelector(state => state.llmContent.chatId)
  const attachments = useSelector(state => state.llmContent.attachments)
  const [attachmentLoading, setAttachmentLoading] = useState(false)
  const attachmentsToCheck = attachments.filter(
    attachment =>
      attachment.succeeded === false &&
      attachment.upload_status !== 'partial_failure' &&
      attachment.upload_status !== 'failed',
  )
  const [attachmentWillAdd, setAttachmentWillAdd] = useState(false)
  const placeholder = 'What should be the title?'

  const handleChatRedirect = () => {
    track('started_building_course')

    setLoading(true)

    if (attachments.length == 0 && fromChat === false) {
      dispatch(llmSetChatId())
      dispatch(
        llmGetChatMessagesSuccess({
          chatId: null,
          messages: [],
          attachments: [],
        }),
      )
    }

    const courseType = creationType === 0 ? 'course' : 'quiz'

    dispatch(
      llmGetTranslatedContentAction(
        description,
        languageSelection.countryCode,
        courseType,
        response => {
          setLoading(false)
          if (attachmentWillAdd === false) {
            history.push(
              `/create-course-with-chat?collectionId=${collectionId}&message=${response}`,
            )
          } else {
            history.push(
              `/create-course-with-chat?collectionId=${collectionId}&chatId=${chatId}&message=${response}`,
            )
          }
        },
      ),
    )
  }

  const [languageSelection, setLanguageSelection] = useState(null) // Start with null

  useEffect(() => {
    setLanguageLoading(true)
    const fetchLocalizationStrings = async () => {
      const res = await getLocalizationStringOfTypeService('course-ui')
      const languageOptions = res.data.languages
      setLanguageSelection(languageOptions.find(x => x.countryCode === 'en'))
      setLanguageLoading(false)
      const inputBase = document.getElementById('title-input')

      if (inputBase) {
        inputBase.focus()
      }
    }
    fetchLocalizationStrings()
  }, [])
  const handleSwitch = () => {
    track('upload_switch_clicked')
    setAttachmentLoading(false)
    setAttachmentWillAdd(!attachmentWillAdd)
    if (attachmentWillAdd === true) {
      setAttachmentLoading(false)

      dispatch(
        llmGetChatMessagesSuccess({
          chatId: chatId,
          messages: [],
          attachments: [],
        }),
      )
    }
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        width: '640px',
        minHeight: '450px',
        alignItems: languageLoading ? 'center' : 'normal',
        justifyContent: languageLoading ? 'center' : 'normal',
      }}
    >
      {languageLoading ? (
        <CircularProgress size={24} />
      ) : (
        <>
          <Typography className={classes.cardTitle}>
            Let AI build your content
          </Typography>
          <Selections
            creationType={creationType}
            setCreationType={setCreationType}
          />
          <CoreTextField
            id="title-input"
            multiline
            value={description}
            onChange={e => setDescription(e.target.value)}
            variant="outlined"
            fullWidth
            label={placeholder}
            marginTop={true}
          />
          {/* Render CountrySelect only when languageSelection is ready */}
          {languageLoading && (
            <div
              style={{
                height: '70px',
                width: '100%',
              }}
            ></div>
          )}
          {!languageLoading && languageSelection && (
            <CountrySelect
              languageSelection={languageSelection}
              setLanguageSelection={setLanguageSelection}
              label="Output Language"
            />
          )}
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
            }}
          >
            <CustomizedSwitch
              onClick={() => handleSwitch()}
              checked={attachmentWillAdd === true}
            />
            <Typography fontSize="14px" fontWeight={400}>
              Upload a resource to guide AI
            </Typography>
          </div>
          {attachmentWillAdd === true && (
            <FileUpload
              attachmentLoading={attachmentLoading}
              setAttachmentLoading={setAttachmentLoading}
            />
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {loading ? (
              <CircularProgress />
            ) : (
              <CoreButton
                disabled={
                  description.length === 0 ||
                  (attachmentWillAdd == true && attachments.length == 0) ||
                  attachmentsToCheck.length != 0 ||
                  languageLoading
                }
                fullWidth
                onClick={handleChatRedirect}
              >
                Start building
              </CoreButton>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(Description)
